import { render, staticRenderFns } from "./NewsPickup.vue?vue&type=template&id=3fb8bff9&v-if=isVisible"
import script from "./NewsPickup.vue?vue&type=script&lang=js"
export * from "./NewsPickup.vue?vue&type=script&lang=js"
import style0 from "./NewsPickup.vue?vue&type=style&index=0&id=3fb8bff9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports